import { TextField, MenuItem } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { StyledButton } from 'styles/common';

import FilterDisplay from './FilterDisplay';

export const ScrollableContainer = styled.div`
  max-height: 27.5vh;
  overflow-y: auto;
`;

export const StyledFilterDisplay = styled(FilterDisplay)`
  width: auto;
  max-width: 29%;
  display: inline-flex;
  border: 1px solid #e1e1e1;
  border-width: 1px 1px 1px 1px;
  border-left-width: 1px;
  padding: 0.5rem 0.6rem;
  ${(props) =>
    props.noLeftBorder &&
    css`
      border-left-width: 0;
    `};
  svg {
    width: 16px;
  }
  ${(props) =>
    props.active &&
    css`
      color: ${(props) => props.theme.palette.primary.main};
      background: #3a8ee91c;
      border-color: ${(props) => props.theme.palette.primary.main};
      border-left-width: 1px;
      svg {
        fill: ${(props) => props.theme.palette.primary.main};
      }
    `};
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: inherit !important;
      opacity: 0.5;
    `}
`;

export const SelectedCounter = styled.span`
  color: ${(props) => props.theme.palette.primary.main};
  font-size: 0.8rem;
  margin-left: 0.25rem;
  ${(props) =>
    props.hiddenText &&
    css`
      opacity: 0;
    `}
`;

export const BlueButton = styled(StyledButton)`
  color: white;
  background: #008ef0;
  min-width: 100px;
  &:disabled {
    color: white;
    opacity: 0.4;
  }
  &:hover {
    background: #008ef0;
  }
`;

export const LastMenuItem = styled(MenuItem)`
  border-top: 1px solid #ddd;
  padding: 0.75rem 1rem;
  margin-bottom: -7px;
  padding-left: 20px !important;
`;

export const MultilineTextField = styled(TextField)`
  width: 100%;
  margin: 0.5rem 0 1.25rem 0;
  .MuiOutlinedInput-multiline {
    padding: 12px 14px;
  }
  textarea {
    font-size: ${(props) => props.theme.typography.body2.fontSize};
  }
  ${(props) =>
    props.loading &&
    css`
      font-style: italic;
    `}
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  margin: 0.5rem 0 1.25rem 0;
  input {
    padding: 10px 14px;
    font-size: ${(props) => props.theme.typography.body2.fontSize};
  }
`;

export const AbsoluteContainer = styled.div`
  position: absolute;
  top: 30px;
  left: 1px;
  z-index: 999;
  ${(props) =>
    props.middle &&
    css`
      left: -20%;
    `}
  ${(props) =>
    props.right &&
    css`
      left: initial;
      right: -80px;
    `}
`;

export const LoadMoreItem = styled(MenuItem)`
  display: flex;
  justify-content: flex-start;
  padding: 0.75rem 1rem;
  padding-left: 20px !important;
  &:disabled {
    color: white;
    opacity: 0.4;
    pointer-events: none;
  }
`;
